package com.nonopn.skywatcher.common.app.pages.map.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.home.LocalThunderDetectionModel
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.weather.CardSwitchSatellite
import com.nonopn.skywatcher.design.theme.AppSizes
import de.drick.compose.hotpreview.HotPreview

@Composable
fun MapOverlay(
    modifier: Modifier,
    model: MainScreenModel
) {
    val state by LocalThunderDetectionModel.current.states.collectAsState()
    val isAdministrator = state.selectedThunderDetection.isAdministrator

    Box(modifier.padding(AppSizes.map.cardVerticalPadding)) {
        MapButtons(
            Modifier.align(Alignment.TopStart),
            model
        )

        Column(
            Modifier.align(Alignment.TopEnd),
            verticalArrangement = Arrangement.spacedBy(
                AppSizes.map.cardVerticalPadding
            ),
            horizontalAlignment = Alignment.End
        ) {
            LightningActivityLegend(
                Modifier.widthIn(150.dp, 160.dp)
                    .height(AppSizes.map.cardLightningLegendHeight)
            )

            CounterLightning(
                Modifier.width(IntrinsicSize.Min).height(AppSizes.map.cardImageAndTextHeight),
                model
            )


            if (isAdministrator) {
                CounterUsers(
                    Modifier.width(100.dp)
                        .height(AppSizes.map.cardImageAndTextHeight),
                    model
                )

                UserAlertLegend(
                    Modifier.widthIn(150.dp, 160.dp)
                )
            }

            /*CardSwitchSatellite(
                Modifier.width(160.dp)
                    .height(AppSizes.map.cardImageAndTextHeight),
                model
            )*/

            /*CardSwitchStormCells(
                Modifier.width(160.dp)
                    .height(AppSizes.map.cardImageAndTextHeight),
                model
            )*/
        }
    }
}

@Composable
@HotPreview(widthDp = 600, heightDp = 400, darkMode = true)
@HotPreview(widthDp = 600, heightDp = 400, darkMode = false)
private fun MapOverlayPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        MapOverlay(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(false, null)
        )
    }
}